import { render, staticRenderFns } from "./ProperSettings.vue?vue&type=template&id=193770e8"
import script from "./ProperSettings.vue?vue&type=script&lang=js"
export * from "./ProperSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports